/* eslint-disable no-console */
<template>
<div>
    <div class="card z-depth-5 p-3">
        <h4 class="text-center font-weight-bold py-3">Add Account</h4>
        <div>
            <!-- Default form login -->
            <form class="border border-light p-5">
                <div class="row">
                    <div class="form-group col-md-6">
                        <label>Title</label>
                        <input type="text" ref="title" class="form-control mb-4" placeholder="Title (Mr,Mrs,Miss,Master,Dr...)">
                    </div>
                    <div class="form-group col-md-6">
                        <label>First Name</label>
                        <input type="text" ref="first_name" class="form-control mb-4" placeholder="First Name">
                    </div>
                    <div class="form-group col-md-6">
                        <label>Last Name</label>
                        <input type="text" ref="last_name" class="form-control mb-4" placeholder="Last Name">
                    </div>
                    <div class="form-group col-md-6">
                        <label>City</label>
                        <input type="text" ref="city" class="form-control mb-4" placeholder="City">
                    </div>
                    <div class="form-group col-md-6">
                        <label>State</label>
                        <input type="text" ref="county" class="form-control mb-4" placeholder="State">
                    </div>
                    <div class="form-group col-md-6">
                        <label>Country</label>
                        <input type="text" ref="country" class="form-control mb-4" placeholder="Country">
                    </div>
                    <div class="form-group col-md-6">
                        <label>Email</label>
                        <input type="email" ref="email" class="form-control mb-4" placeholder="Email">
                    </div>
                    <div class="form-group col-md-6">
                        <label>Password</label>
                        <input type="password" ref="password" class="form-control mb-4" placeholder="Password">
                    </div>
                </div>

                <!-- Sign in button -->
                <button class="btn btn-info btn-block my-4" @click.prevent="addTeacher()">Add Account</button>

            </form>
            <!-- Default form login -->
        </div>
    </div>
</div>
</template>

<script>
import axios from "axios"
export default {
    name: 'AddTeacher',
    components: {

    },
    data() {
        return {
            fastAdminToken : localStorage.getItem("fastAdminToken")
        }
    },
    methods: {
        addTeacher() {
            if (this.$refs.first_name.value == '' ||
                this.$refs.last_name.value == '' ||
                this.$refs.city.value == '' ||
                this.$refs.county.value == '' ||
                this.$refs.country.value == '' ||
                this.$refs.email.value == '' ||
                this.$refs.password.value == '') {
                this.$toast.open({
                    message: "ERROR : All Fields Are Required",
                    type: 'error'
                })
            } else {

                let data = {
                    first_name: this.$refs.first_name.value,
                    last_name: this.$refs.last_name.value,
                    city: this.$refs.city.value,
                    county: this.$refs.county.value,
                    country: this.$refs.country.value,
                    email: this.$refs.email.value,
                    password: this.$refs.password.value,
                    title: this.$refs.title.value
                }
                const config = {
                    headers: {
                        Authorization: "Bearer " + this.fastAdminToken,
                        'Content-Type': 'application/json'
                    }
                }
                this.$toast.open({
                    message: "Processing : Creating Teacher Please Wait...",
                    type: 'info'
                })
                axios.post(this.$apiURI + "/auth/register/teacher", data, config)

                    .then((response) => {
                        if (response.data.error) {
                            this.$toast.open({
                                message: "Error : " + response.data.message,
                                type: 'error'
                            });
                        } else {
                            this.$toast.open({
                                message: "Teacher Created Successfully",
                                type: 'success'
                            })
                        }

                    }).catch((error) => {
                        this.$toast.open({
                            message: "Error : " + error.response.data.message,
                            type: 'error'
                        });
                    })
            }
        }
    }
}
</script>
